import { Select, Pagination } from 'antd';

import styles from './stylesCustomPagination.module.css';

function CustomPagination({
  total,
  pageSize,
  currentPage,
  onPageSizeChange,
  onPageChange,
}) {
  return (
    <div className={styles.paginationContainer}>
      <div className={styles.paginationInfo}>
        <Select
          value={pageSize}
          onChange={onPageSizeChange}
          style={{ width: 75 }}
        >
          <Select.Option value={5}>5</Select.Option>
          <Select.Option value={10}>10</Select.Option>
          <Select.Option value={20}>20</Select.Option>
          <Select.Option value={100}>100</Select.Option>
        </Select>
        <span>per page of {total} events</span>
      </div>
      <Pagination
        current={currentPage}
        total={total}
        pageSize={pageSize}
        showSizeChanger={false}
        onChange={onPageChange}
        itemRender={(page, type, originalElement) => {
          if (type === 'page') {
            return (
              <span className={page === currentPage ? 'active' : ''}>
                {page}
              </span>
            );
          }
          return originalElement;
        }}
      />
    </div>
  );
}

export default CustomPagination;
